
import user from './modules/user'
import home from './modules/home'
import company from './modules/company'
import cdr from './modules/cdr'
import scheme from './modules/scheme'
import quotation from './modules/quotation'
import ccReleaseReport from './modules/ccReleaseReport'
import sysProdType from './modules/sysProdType'
import demand from './modules/demand'
import sysApp from './modules/sysApp'
import ccProjectInfo from './modules/ccProjectInfo'
import ccCompanySupplyDemand from './modules/ccCompanySupplyDemand'

/**
 * 模块集合
 */
export default {
 /**
  * 用户模块
  */
 user,
 /**
  * 首页模块
  */
 home,
 /**
  * 企业模块
  */
 company,
 /**
  * CDR报价模块
  */
 cdr,
 /**
  * 方案接口
  */
 scheme,
 /**
 * 报价单接口
 */
 quotation,
 /**
 * 企业统计信息接口
 */
 ccReleaseReport,
 /**
 * 制作类型
 */
 sysProdType,
 /**
 * 平台需求
 */
 demand,
 /**
 * 平台应用
 */
 sysApp,
 /**
  * 方案类型
  */
 ccProjectInfo,
 /**
  * 保存供需
  */
 ccCompanySupplyDemand
}



// WEBPACK FOOTER //
// ./src/store/modules.js